import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useAdminEditUser = () => {
  const queryClient = useQueryClient();

  return apiClient.admin.editUser.useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-users-list'] });
      toast.success('User updated successfully!');
    },
    onError: (error: any) => {
      showErrorToast(error, 'Error updating user!');
    },
  });
};
